import useGetState from './use-get-state.js';
/**
 * This hook provides synchronous access to enable service request persistence.
 * Prevents the need for a React.Suspense when you just want to enable storage.
 *
 * @template SVC
 * @param {({
 *     serviceState: IServiceState<SVC>|IAnonymousServiceState<SVC>,
 *     defaultValue?: SVC['response'],
 *   })} {
 *     serviceState,
 *     defaultValue,
 *   }
 * @returns
 */
export const useServiceRequestPersistence = (serviceState) => {
    // Enable request state persistence.
    // This will remember the currently selected order when you restart the application.
    //
    // NOTE: Persisted values are per user
    //
    useGetState(serviceState.storage);
    return;
};
export default useServiceRequestPersistence;
//# sourceMappingURL=use-service-request-persistence.js.map